import { AcquiringChannel, DeliveryDTO } from 'src/features/common/types';
import { CardMachine } from 'src/features/common/types/application/card-machine';

export function getCardMachinesDTO(deliveries: DeliveryDTO[]) {

  const machines: CardMachine[] = [];

  for (const delivery of deliveries) {

    const serialNumbers = delivery.serial_numbers || [];
    const friendlyTerminalNames = delivery.friendlyTerminalName || [];
    for (let index = 0; index < serialNumbers.length; index++) {
      const serialNumber = serialNumbers[index];
      const friendlyName = friendlyTerminalNames[index];

      machines.push({
        barcode: serialNumber,
        name: friendlyName,
        acquiringChannel: delivery.acquiring_channel as AcquiringChannel,
        productId: delivery.device_id || ''
      })
    }

  }

  return machines

}